import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'

import classes from './GridItem.module.scss'

/** @type {import("./types").default} */
const GridItem = ({ className, children, ...otherProps }) => {
  return (
    <Grid item xs zeroMinWidth className={clsx('GridItem', className, classes.gridItem)} {...otherProps}>
      {children}
    </Grid>
  )
}

export default GridItem
